import { TrackingAnalytics } from './TrackingAnalytics';

const extendPopinTime = (extended, amount) => {
  const payload = { extended };
  if (!!amount) {
    payload.extended_amount = amount;
  }
  TrackingAnalytics.send('PP-Extend POPin Time', payload);
};

const badClick = (element) => {
  const props = {
    item_clicked: element
  };
  TrackingAnalytics.send('Presentation-Failed click', props)
};

export const PresentationPageAnalytics = {

  didNotExtend () {
    extendPopinTime(false);
  },

  extendedTime (amount) {
    extendPopinTime(true, amount);
  },

  // Presentation Mode
  enterPresentationView () {
    const props = {
      click_source: 'CR'
    };
    TrackingAnalytics.send('Enter Pres View', props);
  },
  presentationViewLoaded () {
    TrackingAnalytics.send('Presentation~Page loaded');
  },
  fullScreenModeEntered() {
    TrackingAnalytics.send('Presentation-Fullscreen entered');
  },
  fullScreenModeExited(duration) {
    const props = {
      minutes_in_fullscreen: duration
    };
    TrackingAnalytics.send('Presentation-Fullscreen exited', props);
  },
  fullScreenModeChanged (isFullscreen, duration) {
    if(!!isFullscreen){
      this.fullScreenModeEntered();
    } else {
      this.fullScreenModeExited(duration)
    }
  },
  liveQuestionEdit () {
    this.liveQuestionChanges('question-edited');
  },
  liveQuestionDelete () {
    this.liveQuestionChanges('question-deleted');
  },
  liveQuestionChanges (type) {
    let props = {
      type: type
    };
    TrackingAnalytics.send('Presentation-Live creator activity', props);
  },
  liveContribution (type) {
    let props = {
      type: type
    };
    TrackingAnalytics.send('Presentation-Live contribution', props);
  },
  liveIdeaCreated() {
    this.liveContribution('idea-added')
  },
  liveResponseToScaleBinaryMultiple() {
    this.liveContribution('idea-chosen')
  },
  liveCommentCreated() {
    this.liveContribution('comment-added');
  },
  liveUpvote(isIdea) {
    this.liveContribution(`${isIdea ? 'idea' : 'comment'}-upvoted`)
  },
  liveDownvote(isIdea) {
    this.liveContribution(`${isIdea ? 'idea' : 'comment'}-downvoted`)
  },
  sortDropdownClicked () {
    TrackingAnalytics.send('Presentation-Sort dropdown clicked');
  },
  sortChanged (newSort, prevSort, duration) {
    let props = {
      new_sort: newSort,
      prev_sort: prevSort,
      minute_duration_of_prev_sort: duration
    };
    TrackingAnalytics.send('Presentation-Sort changed', props);
  },
  cardFocused () {
    TrackingAnalytics.send('Presentation-Card focused')
  },
  cardCollapsed (withButton) {
    let props = {
      close_btn_clicked: !!withButton
    };
    TrackingAnalytics.send('Presentation-Card collapsed', props)
  },
  failedUpvoteAttempt () {
    badClick('upvote')
  },
  failedDownvoteAttempt () {
    badClick('downvote')
  },
  failedCommentAttempt () {
    badClick('comment');
  },
  failedPopinLogoClick () {
    badClick('popin-logo')
  },
  failedMarketingSiteAttempt () {
    badClick('popinnow.com')
  },
  previousPopinStartTimer () {
    TrackingAnalytics.setTimer('Presentation-Switch to previous');
  },
  switchToPrevious (index, questionCount, usedKeyboard, usedHoverBtn) {
    const props = {
      used_keyboard: !!usedKeyboard,
      switched_to_question: index,
      question_count: questionCount,
      used_hover_btn: usedHoverBtn
    };
    TrackingAnalytics.send('Presentation-Switch to previous', props)
  },
  nextPopinStartTimer () {
    TrackingAnalytics.setTimer('Presentation-Switch to next');
  },
  switchToNext (index, questionCount, usedKeyboard, usedHoverBtn) {
    const props = {
      used_keyboard: !!usedKeyboard,
      switched_to_question: index,
      question_count: questionCount,
      used_hover_btn: usedHoverBtn
    };
    TrackingAnalytics.send('Presentation-Switch to next', props)
  }
};
